import React from 'react'
import moment from 'moment'

const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

const calculateCurrentValue = (event: React.KeyboardEvent<HTMLInputElement>, firstNumberLimit: number, allNumberLimit: number) => {
    const target = event.currentTarget
    const key = event.key
    const currentValue = target.value
    const selectionStart = target.selectionStart || 0
    const selectionEnd = target.selectionEnd || 0

    if (currentValue === '00' && selectionEnd - selectionStart === 0) event.preventDefault()

    let stringValue = ''
    if (selectionStart === 0 && selectionEnd === 0) {
        stringValue = `${key}${currentValue}`
    } else if (selectionStart === 0 && selectionEnd === 1) {
        stringValue = `${key}${currentValue.substring(1, 2)}`
    } else if (selectionStart === 0 && selectionEnd === 2) {
        stringValue = `${key}`
    } else if (selectionStart === 1 && selectionEnd === 1) {
        stringValue = `${currentValue.substring(0, 1)}${key}${currentValue.substring(1, 2) ? currentValue.substring(1, 2) : ''}`
    } else if (selectionStart === 1 && selectionEnd === 2) {
        stringValue = `${currentValue.substring(0, 1)}${key}`
    } else if (selectionStart === 2 && selectionEnd === 2) {
        stringValue = `${currentValue}${key}`
    }

    if (stringValue.length === 2) {
        if (Number(stringValue) > allNumberLimit) event.preventDefault()
    } else {
        if (Number(stringValue) > firstNumberLimit) event.preventDefault()
    }
}

export const keyPressNumberOnly = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!numbers.includes(event.key)) {
        event.preventDefault()
    }
}

export const keyPressNumberTime = (event: React.KeyboardEvent<HTMLInputElement>) => {
    keyPressNumberOnly(event)
    calculateCurrentValue(event, 2, 24)
}

export const keyPressNumberMinute = (event: React.KeyboardEvent<HTMLInputElement>) => {
    keyPressNumberOnly(event)

    calculateCurrentValue(event, 5, 59)
}

export const keyPressNumberPhone = (event: React.KeyboardEvent<HTMLInputElement>) => {
    keyPressNumberOnly(event)

    const currentValue = event.currentTarget.value
    if (currentValue) {
        if (currentValue.length + 1 >= 12) event.preventDefault()
    }
}

export const markDayHyphen = (val: string | undefined, defaultStr?: string) => {
    if (val) {
        return moment(val).format('YY-MM-DD')
    }
    return defaultStr ? defaultStr : '-'
}

export const markHyphen = (val: number | string | undefined, defaultStr?: string) => {
    if (val) {
        return val
    }
    return defaultStr ? defaultStr : '-'
}

export const includeComma = (number: number | string | undefined, defaultStr?: string) => {
    if (!number) {
        return defaultStr ? defaultStr : ''
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const onKeyDownCheckEnter = (e: React.KeyboardEvent<HTMLDivElement>, action: Function) => {
    if (e.key === 'Enter') {
        action()
    }
}

export const lpad = (padLen: number, padStr: string, str: string) => {
    if (String(padStr).length > padLen) {
        return str + ''
    }

    while (str.length < padLen) {
        str = padStr + str
        str = str.length >= padLen ? str.substring(0, padLen) : str
    }

    return str
}
